import React from "react";
import Timeline from "sections/about/parts/Timeline";
import styled, { keyframes } from "styled-components";

const TabContainer = styled.div`
  min-height: 350px;
  margin-top: 20px;
  @media (max-width: 767px) {
    margin-top: 50px;
    padding: 0 20px;
  }
`;
const TabSelectors = styled.div`
  display: flex;
  @media (max-width: 410px) {
    justify-content: space-evenly;
  }
`;

const ColorAnimation = keyframes`
        0%  {border-color: #04e5e5;}
        10% {border-color: #f37055;}
        20% {border-color: #ef4e7b;}
        30% {border-color: #a166ab;}
        40% {border-color: #5073b8;}
        50% {border-color: #04e5e5;}
        60% {border-color: #07b39b;}
        70% {border-color: #6fba82;}
        80% {border-color: #5073b8;}
        90% {border-color: #1098ad;}
        100% {border-color: #f37055;}
    `;

const TabSelector = styled.button`
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  background-color: transparent;
  border: none;
  margin: 0 10px 0 0;
  border-bottom: 2px solid #fff;
  transition: 0.5s;
  &:hover,
  &.active {
    animation: ${ColorAnimation} 10s infinite alternate;
  }
  &:focus {
    outline: none;
  }
  .full-text {
    display: inline;
  }
  .short-text {
    display: none;
  }
  @media (max-width: 767px) {
    font-size: 18px;
  }
  @media (max-width: 410px) {
    .full-text {
      display: none;
    }
    .short-text {
      display: inline;
    }
  }
`;

const Tabs = styled.div`
  margin-top: 20px;
`;

const Fade = keyframes`
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    `;

const Tab = styled.div`
  display: none;
  animation: ${Fade} 1s forwards;
`;

const SkillTab = styled.div`
  display: none;

  animation: ${Fade} 1s forwards, ${ColorAnimation} 10s infinite alternate;
`;

//     const ColorAnimationText = keyframes`
// 0%  {color: #04e5e5;}
// 10% {color: #f37055;}
// 20% {color: #ef4e7b;}
// 30% {color: #a166ab;}
// 40% {color: #5073b8;}
// 50% {color: #04e5e5;}
// 60% {color: #07b39b;}
// 70% {color: #6fba82;}
// 80% {color: #5073b8;}
// 90% {color: #1098ad;}
// 100% {color: #f37055;}
// `;

const SkillText = styled.div`
  margin-top: 5px;
  margin-right: 15px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  @media (max-width: 767px) {
    font-size: 12px;
  }
`;

const CategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
  width: calc(50% - 20px);
  @media (max-width: 767px) {
    width: 100%;
    margin: 5px 0;
  }
`;

const CategoryTitle = styled.h4`
  font-size: 18px;
  font-weight: bold;
  color: #04e5e5;
  margin-bottom: 5px;
  text-transform: uppercase;
  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const SkillsList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

class TabsPart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "skills",
    };
  }

  render() {
    return (
      <TabContainer>
        <TabSelectors>
          <TabSelector
            className={this.state.tab === "skills" ? "active" : ""}
            onClick={() => this.setState({ tab: "skills" })}
          >
            Skills
          </TabSelector>
          <TabSelector
            className={this.state.tab === "experience" ? "active" : ""}
            onClick={() => this.setState({ tab: "experience" })}
          >
            <span className="full-text">Experience</span>
            <span className="short-text">Exp</span>
          </TabSelector>
          <TabSelector
            className={this.state.tab === "education" ? "active" : ""}
            onClick={() => this.setState({ tab: "education" })}
          >
            <span className="full-text">Education</span>
            <span className="short-text">Edu</span>
          </TabSelector>
        </TabSelectors>

        <SkillTab
          style={
            this.state.tab === "skills"
              ? {
                  borderLeft: "2px solid white",
                  borderRight: "2px solid white",
                  minHeight: "300px",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                  alignContent: "flex-start",
                  justifyContent: "flex-start",
                  padding: "10px",
                }
              : {
                  display: "none",
                }
          }
        >
          <CategoryContainer>
            <CategoryTitle>Front-end</CategoryTitle>
            <SkillsList>
              <SkillText>React.js</SkillText>
              <SkillText>HTML5/CSS3</SkillText>
              <SkillText>JavaScript (ES2025+)</SkillText>
              <SkillText>Angular</SkillText>
            </SkillsList>
          </CategoryContainer>

          <CategoryContainer>
            <CategoryTitle>Back-end</CategoryTitle>
            <SkillsList>
              <SkillText>Next.js</SkillText>
              <SkillText>Node.js</SkillText>
              <SkillText>Express</SkillText>
              <SkillText>MySQL</SkillText>
              <SkillText>MongoDB</SkillText>
              <SkillText>Firebase</SkillText>
            </SkillsList>
          </CategoryContainer>

          <CategoryContainer>
            <CategoryTitle>AI tools & Agents</CategoryTitle>
            <SkillsList>
              <SkillText>Gemini</SkillText>
              <SkillText>Claude Code</SkillText>
              <SkillText>ChatGPT</SkillText>
            </SkillsList>
          </CategoryContainer>

          <CategoryContainer>
            <CategoryTitle>Cybersecurity</CategoryTitle>
            <SkillsList>
              <SkillText>OWASP Top 10</SkillText>
              <SkillText>Burp Suite</SkillText>
              <SkillText>Nmap</SkillText>
              <SkillText>Metasploit</SkillText>
            </SkillsList>
          </CategoryContainer>

          <CategoryContainer>
            <CategoryTitle>Penetration Testing</CategoryTitle>
            <SkillsList>
              <SkillText>Web/Network Pentesting</SkillText>
              <SkillText>Win/Linux PrivEsc</SkillText>
            </SkillsList>
          </CategoryContainer>

          <CategoryContainer>
            <CategoryTitle>Defensive & Ops</CategoryTitle>
            <SkillsList>
              <SkillText>SIEM</SkillText>
              <SkillText>SOC Operations</SkillText>
              <SkillText>Bash/PowerShell</SkillText>
              <SkillText>Git</SkillText>
            </SkillsList>
          </CategoryContainer>
        </SkillTab>

        <Tabs>
          <Tab
            style={{
              display: this.state.tab === "experience" ? "block" : "none",
            }}
          >
            <Timeline
              data={{
                "04/2020": {
                  title: "Full Stack Developer Intern",
                  institution: "JIBB",
                  description:
                    "JIBB provide products that implemented deep learning and motion detection technology to capture user’s handwriting on whiteboard/paper from the camera and convert it into a digital version for online meeting purpose.I developed a web prototype of JIBB product that combined both JIBB and CISCO Webex technology. This makes it possible for the user to using JIBB products through Webex meetings. I developed a desktop application as an image processing toolkit by using Java and JavaFX. This image processing tool replaced the legacy python tools and became one part of the internal developing infrastructure using by all developers in the company.",
                },
                // "11/2020": {
                //   title: "Web Developer",
                //   institution: "Totally Pets",
                //   description: "",
                // },
              }}
            />
          </Tab>
          <Tab
            style={{
              display: this.state.tab === "education" ? "block" : "none",
            }}
          >
            <Timeline
              data={{
                "2012": {
                  title: "Bachelor of Commerce in Accounting",
                  institution: "Shandong Institute of Business and Technology",
                  description: "",
                },
                "2018": {
                  title: "Bachelor of Science in Information Technology",
                  institution: "University of Technology Sydney",
                  description: "",
                },
              }}
            />
          </Tab>
        </Tabs>
      </TabContainer>
    );
  }
}

export default TabsPart;
